export const FETCH_SUBJECT_LIST = 'FETCH_SUBJECT_LIST';
export const FETCH_SUBJECT_LIST__SUCCESS = 'FETCH_SUBJECT_LIST__SUCCESS';
export const FETCH_SUBJECT_LIST__FAILURE = 'FETCH_SUBJECT_LIST__FAILURE';

export const fetchSubjectList = () => ({ type: FETCH_SUBJECT_LIST });
